import styled from 'styled-components';
import PropTypes from 'prop-types';

const PageContainer = ({ children }) => {
  return <Container>{children}</Container>;
};

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageContainer;

const Container = styled.div`
  margin: 0 4rem;

  @media print {
    margin: 0 8mm;
  }
`;
